/** Gmail calls them labels, Outlook categories; cards use the inbox's own word. */
export type ResourceKind = 'label' | 'category'

export function mailboxWords(kinds: ResourceKind[]) {
  const set = new Set(kinds)
  if (set.size === 1 && set.has('category'))
    return {
      one: 'category',
      many: 'categories',
      done: 'categorized',
      none: 'No category',
    }
  if (set.size > 1)
    return {
      one: 'label or category',
      many: 'labels and categories',
      done: 'labelled',
      none: 'No label or category',
    }
  return { one: 'label', many: 'labels', done: 'labelled', none: 'No label' }
}
